import { useQuery } from '@tanstack/react-query';

import { seasonDivisionKeys } from '@/hooks/leagueSeasonDivision/seasonDivisionKeys';
import { getTeamLeagueSeasonDivision } from '@/infrastructure/network/data/season';
import { useOrganizationStore } from '@/store/organization-store';

export const useTeamLeagueSeasonDivision = ({
	teamLeagueUuid,
	seasonUuid,
	divisionUuid
}: {
	teamLeagueUuid: string;
	seasonUuid: string;
	divisionUuid: string;
}) => {
	const store = useOrganizationStore();

	const isEnabled = Boolean(seasonUuid && divisionUuid);

	return useQuery({
		queryKey: seasonDivisionKeys.seasonDivisionInfo(store.organizationUuid, teamLeagueUuid, seasonUuid, divisionUuid),
		queryFn: () =>
			getTeamLeagueSeasonDivision({ organizationUuid: store.organizationUuid, teamLeagueUuid: store.teamLeagueUuid, seasonUuid, divisionUuid }),
		enabled: isEnabled
	});
};
